import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';

import { LabTestingStandard, LabTestingStandardSearchCommand } from '../../models/lab-testing';
import { ApiResponse } from '@card-software/nexus-utilities';

@Injectable({
  providedIn: 'root',
})
export class LabTestingStandardProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.productionApi + '/api/v1/lab-testing-standard';

  public getAll(): Observable<ApiResponse<LabTestingStandard[]>> {
    return this.httpClient.get<ApiResponse<LabTestingStandard[]>>(`${this.baseUrl}/all`);
  }

  public getById(id: string): Observable<ApiResponse<LabTestingStandard>> {
    return this.httpClient.get<ApiResponse<LabTestingStandard>>(`${this.baseUrl}/${id}`);
  }

  public create(standard: LabTestingStandard): Observable<ApiResponse<LabTestingStandard>> {
    return this.httpClient.post<ApiResponse<LabTestingStandard>>(`${this.baseUrl}`, standard);
  }

  public update(standard: LabTestingStandard): Observable<ApiResponse<LabTestingStandard>> {
    return this.httpClient.put<ApiResponse<LabTestingStandard>>(`${this.baseUrl}/${standard.id}`, standard);
  }

  public delete(id: string): Observable<ApiResponse<void>> {
    return this.httpClient.delete<ApiResponse<void>>(`${this.baseUrl}/${id}`);
  }

  public search(searchCommand: LabTestingStandardSearchCommand): Observable<ApiResponse<LabTestingStandard[]>> {
    return this.httpClient.post<ApiResponse<LabTestingStandard[]>>(`${this.baseUrl}/search`, searchCommand);
  }

  public getByCustomerAndComposition(customerReference: string, composition: string): Observable<ApiResponse<LabTestingStandard>> {
    const params = new HttpParams().set('customerReference', customerReference).set('composition', composition);

    return this.httpClient.get<ApiResponse<LabTestingStandard>>(`${this.baseUrl}/by-customer-composition`, { params });
  }
}
